export type EntitlementPlan = "free" | "plus";
export type EntitlementStatus =
  | "free"
  | "active"
  | "cancelled"
  | "refunded"
  | "disputed"
  | "chargebacked"
  | "verification_grace"
  | "verification_expired";

export type EntitlementSnapshot = {
  contractVersion: "subscription-v1";
  plan: EntitlementPlan;
  label: "Free" | "Verbalore Plus";
  billingActive: boolean;
  source: "default_free" | "commerce_projection";
  status: EntitlementStatus;
  capabilities: {
    completeReadingToCommand: true;
    learnerOwnedData: true;
    permanentFreeShelf: true;
    foundationalPractice: true;
    privateImports: true;
    sustainedPrivateImports: boolean;
    memberCorpusBreadth: boolean;
    deeperPractice: boolean;
    personalization: boolean;
    completeCorpus: boolean;
    advancedPractice: boolean;
    longitudinalAnalysis: boolean;
  };
  commerce: {
    checkoutUrl: string | null;
    manageUrl: string | null;
    purchasesEnabled: boolean;
    recoveryEnabled: boolean;
    status: EntitlementStatus;
    validUntil: string | null;
    lastVerifiedAt: string | null;
    providerGraceUntil: string | null;
    providerDegraded: boolean;
  };
};

export function entitlementSnapshot(
  plan: EntitlementPlan,
): EntitlementSnapshot {
  const plus = plan === "plus";
  return {
    contractVersion: "subscription-v1",
    plan,
    label: plus ? "Verbalore Plus" : "Free",
    billingActive: false,
    source: plus ? "commerce_projection" : "default_free",
    status: plus ? "active" : "free",
    capabilities: {
      completeReadingToCommand: true,
      learnerOwnedData: true,
      permanentFreeShelf: true,
      foundationalPractice: true,
      privateImports: true,
      sustainedPrivateImports: plus,
      memberCorpusBreadth: false,
      deeperPractice: false,
      personalization: false,
      completeCorpus: false,
      advancedPractice: false,
      longitudinalAnalysis: false,
    },
    commerce: {
      checkoutUrl: null,
      manageUrl: null,
      purchasesEnabled: false,
      recoveryEnabled: false,
      status: plus ? "active" : "free",
      validUntil: null,
      lastVerifiedAt: null,
      providerGraceUntil: null,
      providerDegraded: false,
    },
  };
}

export const FREE_ENTITLEMENT = entitlementSnapshot("free");
